import { Observable } from "rxjs";


export class CurrentSelection {
  public equipment: Equipment = new Equipment();
  public jobSite: JobSite = new JobSite();
  public customer: Customer = new Customer();
  public family: Family = new Family();
  public make: Make = new Make();
  public model: Model = new Model();
  public system: UCSystem = new UCSystem();
  public startDate: Date = new Date(Date.now());
  public endDate: Date = new Date(Date.now());
  public isSearchSelected: boolean = false

  public componentType: number;
  public examiner: Customer = new Customer();
  public dealer: Customer = new Customer();
  public lu_UcStatusId: number[];
}
export class CompartSelection extends CurrentSelection {
  public compartTypeId: CompartTypeId = new CompartTypeId();
}

export class CompartTypeId {
  public Id = 0;

}

export class SelectionLists {
  public customerList: Customer[] = [];
  public jobSiteList: JobSite[] = [];
  public equipmentList:  Equipment[] = [];
  public systemList: UCSystem[] = [];
  public familyList: Family[] = [];
  public makeList: Make[] = [];
  public modelList: Model[] = [];
  public examinerList: Customer[] = [];
  public dealerList: Customer[] = [];
  public type: Type[] = []
  public inventoryStatus: InventoryStatus[] = [];
  public luUCIInventoryStatusModel: luUCIInventoryStatusModel[] = [];

}

export class Type {
  public Id = 0;
  public Title = '';
}

export class luUCIInventoryStatusModel {
  public Id = 0;
  public Title = '';
}

export class InventoryStatus {
  public Id = 0;
  public Title = '';
}

export class Equipment {
  public Id = 0;
  public JobSiteId = 0;
  public Serial = '';
  public Unit = '';
  public Systems: UCSystem[] = [];
  public Make: Make = new Make();
  public Model: Model = new Model();
  public Family: Family = new Family();
  public SmuAtSetup = 0;
  public SetupDate: Date = new Date();
  public AddiUnit = '';
  public PropelAtSetup = 0;
  public FamilyId: number = 0;
  public EnableDistTravelledTracking: boolean = false;
  public ShowPropelHrsPerc: boolean = false;
  public DistanceOnEqAtInstall: number = 0;
  public DistanceOnEquipment: number = 0;
}

export class MakeModelFamily {
  Id = 0;
  public Make: Make = new Make();
  public Model: Model = new Model();
  public Family: Family = new Family();
}

export class JobSite {
  public Id = 0;
  public CustomerId = 0;
  public Title = '';
  public Systems: UCSystem[];
}
export class Customer {
  public Id = 0;
  public Title = '';
   public EncryptedTitle = '';
  public DealerId = 0;
}

export class Family {
  public Id = 0;
  public Title = '';
  public Symbol: string;
  public ExistingCount = 0;
  public ShowPropelHrsPerc: boolean;
  public EnableFrameConfiguration: boolean;
  public EnableCannonType: boolean;
}
export class Make {
  public Id = 0;
  public Symbol = '';
  public Title = '';
  public ExistingCount = 0;
  public isUndecarriage: boolean
  public isComponent?: boolean
  public isOEM?: boolean
}
export class Model {
  public Id = 0;
  public MakeId = 0;
  public FamilyId = 0;
  public ExistingCount = 0;
  public Title = '';
}
export class GlobalLabels {
  currentPageTitle = '';
  currentPageHeader = '';
  backRoute = '';
}
export class PageSetting {
  public Id: number;
  public pageId: number;
  public pageTitle: string;
}
export class PageComponentList {
  public pageId: number;
  public childComponentSelector: string;
  public included = false;
}
export class MenuIdLevel {
  public selectedMenuId = 0;
  public selectedLevel = 0;
}

export enum Side {
  Unknown = 0,
  Left = 1,
  Right = 2,
  Both = 3
}

export enum SystemType {
  Unknown = 0,
  Chain = 1,
  Frame = 2,
  Idler = 3
}


export class ResultMessage {
  public Id = 0;
  public OperationSucceed = true;
  public LastMessage: string;
  public ActionLog: string;
}

export class UserSelectedIds {
  public CustomerId = 0;
  public JobSiteId = 0;
  public EquipmentId = 0;
  public FamilyId = 0;
  public MakeId = 0;
  public ModelId = 0;
}
export enum ComponentType {
  Link = 230,
  Bushing = 231,
  Shoe = 232,
  Idler = 233,
  CarrierRoller = 234,
  TrackRoller = 235,
  Sprocket = 236,
  Guard = 237,
  TrackElongation = 240
}

export class Tuple {
  public m_Item1: any;
  public m_Item2: any;
}

export class Tuple3 {
  public m_Item1: any;
  public m_Item2: any;
  public m_Item3: any;
}

export class SerializedTuple {
  public Item1: any;
  public Item2: any;
}

export class JobRole {
  public Id: number;
  public Name: string;
  public AllowEdit: boolean;
}
//job role permission details
export class loadSelectedJobRoleData {
  Id: number;
  Name: string;
}

export class getJobRoleDetails {
  JobRoleId: number;
  RoleName: string;
  createdByUser: string;
  Active: boolean;
  RoleNote: string;
  ChangeGroup: boolean;
  AllowEdit: boolean;

}



export class JobRoleTable {
  JobRoleId: number;
  UserName: string;
  startDate: string;
  endDate: string;
  Active: boolean;
  userId: number;
  Name: string;
}

export class jobRolePermissions {
  JobRoleId: number
  public Menu_L1: MenuListVM[];
  public Menu_L2: MenuListVM[];
  public Menu_L3: MenuListVM[];
}

export class MenuListVM {
  ObjectId: number;
  ID: number;
  Name: string;
  Active: boolean;
  linkMenuL1: number;
  linkMenuL2: number;
  //linkMenuL3:number ; 
}



export class UserViewModel {
  public UserId = 0;
  public AspNetUserId = '';
  public Name = 'Unknown';
}

export class EvalDetailsV {
  public Reading = 0;
  public ObservationNote: string;
  public EvalCode = 'U';
}

export class Loading {
  public LoadingItem = 0;
  public Loading = false;
}

export class UCSystem {
  public Id = 0;
  public SystemType: SystemType = SystemType.Unknown;
  public Side: Side = Side.Unknown;
  public Serial = '';
  public EquipmentId = 0;
  public JobsiteId = 0;
  public Make: Make = new Make();
  public Model: Model = new Model();
  public Family: Family = new Family();

}



export class jobRolePermissionsforSafetyVM {
  public JobRoleId: number
  public Name: string
  public jobpermissinID: number
  public jobRolePermissions: jobRoleSafety[]
}


export class jobRoleSafety {
  public ID: number
  public Name: string
  public Active: boolean
}

export class SafetyPositionsVM {
  public Id: number
  public positionName: string
  public Description: string
  public CreatedDate: Date
  public ModifiedDate: Date
  public updatedUserID: number
  public updatedUserName: string
  public Active: boolean;
}

export class UserOverviewModel {
  public UserId: number
  public FullName: string
  public UserName: string
  public TeamName: string
  public Email: string
  public Access: string
  public Disabled: boolean
  public USI: string
  public positionID: number
  public select: boolean
}


export class JobPositionsForms {
  public FormID: number
  public FormCategory: string
  public FormName: string
  public isDigital: boolean
  public select: boolean
  public positionID: number
}

export class DispalyMultiselect {
    public display :string;
    public Value: string;
}
export interface UnitNumberModel {
  EquipmentId: number;
  UnitNumber: string;
  SerialNumber: string;
}
export interface EquipmentModelVm {
  Data: UnitNumberModel[];
  Status: number;
  Message: string;
}